import { constructs } from "../api/contructs";
import { CreateGenericReducer } from "./CreateGenericReducer";

export const PagesReducer = CreateGenericReducer(constructs.page);
